export function orderByCustomFieldDefinitionsOrder<T extends { id: string }>(
  customFieldsDefinition: { id: string }[],
  customFieldValuesToSort: T[],
): T[] {
  return customFieldValuesToSort.sort((a, b) => {
    const aIndex = customFieldsDefinition.findIndex(i => i.id === a.id);
    const bIndex = customFieldsDefinition.findIndex(i => i.id === b.id);
    return aIndex - bIndex;
  });
}
